export default {
  SET_BOOKMARKS: (state, payload) => (state.bookmarks = payload)
}
